import firebase from 'firebase';
import { db, storage } from './firebase';
import { FIRESTORE_KEYS } from '../utils/constants';

export default function useTeacherService() {
  const createTeacher = (teacherId, data) =>
    db
      .collection(FIRESTORE_KEYS.TEACHERS)
      .doc(teacherId)
      .set({
        ...data,
        meta: {
          createdDate: firebase.firestore.FieldValue.serverTimestamp(),
          modifiedDate: firebase.firestore.FieldValue.serverTimestamp(),
        },
      });

  const updateTeacher = (teacherId, data) => db.collection(FIRESTORE_KEYS.TEACHERS).doc(teacherId).update(data);

  const deleteTeacher = (id) => db.collection(FIRESTORE_KEYS.TEACHERS).doc(id).delete();

  const addTeacherImage = (docId, image) => {
    const ref = storage.ref(`${FIRESTORE_KEYS.TEACHERS}/${docId}/${image.name}`);
    return ref.put(image).then(() => ref.getDownloadURL());
  };

  return { createTeacher, updateTeacher, deleteTeacher, addTeacherImage };
}
